import { render } from "./TagLock.vue?vue&type=template&id=10dca482&scoped=true"
const script = {}

import "./TagLock.vue?vue&type=style&index=0&id=10dca482&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10dca482"]])

export default __exports__